import React, { useState, useEffect } from "react";
import PropTypes from 'prop-types';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap";
import { useNavigate, Link } from "react-router-dom";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import withRouter from "components/Common/withRouter";
import user1 from "../../../assets/images/users/icon.png";

const ProfileMenu = props => {
  const [menu, setMenu] = useState(false);
  const [username, setUsername] = useState("");
  const [userRole, setUserRole] = useState(""); // Track user role in state
  const navigate = useNavigate(); // Initialize navigate

  useEffect(() => {
    const authUser = JSON.parse(localStorage.getItem("authUser"));
    if (authUser) {
      setUserRole(authUser.role); // Set role from authUser
      setUsername(authUser.username || "User"); // Default to "Admin" if username is not set
    }
  }, [props.success]);

  return (
    <React.Fragment>
      <Dropdown isOpen={menu} toggle={() => setMenu(!menu)} className="d-inline-block">
        <DropdownToggle className="btn header-item" id="page-header-user-dropdown" tag="button">
          <img className="rounded-circle header-profile-user" src={user1} alt="Header Avatar" />
          <span className="d-none d-xl-inline-block ms-2 me-1">{username}</span>
          <i className="mdi mdi-chevron-down d-none d-xl-inline-block" />
        </DropdownToggle>
        <DropdownMenu className="dropdown-menu-end">
          
          {/* Render Create User and Manage Users only for admin role */}
          {(userRole === "admin" || userRole === "coordinator") && (
            <>
              <DropdownItem tag="a" href="/register">
                <i className="bx bx-user font-size-16 align-middle me-1" />
                {props.t("Create User")}
              </DropdownItem>
              <DropdownItem tag="a" href="/admin/users">
                <i className="bx bx-group font-size-16 align-middle me-1" />
                {props.t("Manage Users")}
              </DropdownItem>
            </>
          )}

          <div className="dropdown-divider" />
          <Link to="/logout" className="dropdown-item">
            <i className="bx bx-power-off font-size-16 align-middle me-1 text-danger" />
            <span>{props.t("Logout")}</span>
          </Link>
        </DropdownMenu>
      </Dropdown>
    </React.Fragment>
  );
};

ProfileMenu.propTypes = {
  success: PropTypes.any,
  t: PropTypes.any
};

const mapStatetoProps = state => {
  const { error, success } = state.Profile;
  return { error, success };
};

export default withRouter(
  connect(mapStatetoProps, {})(withTranslation()(ProfileMenu))
);
